export const ENV = {
  DEV: "dev",
  STAGING: "stag",
  PROD: "prod",
};

export const STORAGE_KEY = {
  REDBRICK_TOKEN: "redbrickToken",
  LANG: "lang",
  SOCIAL_TOKEN: "socialToken",
  LAST_LOGGEDIN_SNS: "lastLoggedInSns",
  recentlyUsedAssets: "recently_used_assets",
  recentSearchKeyword: "recent_search_keyword",
};
